import React from 'react';

interface Props {

}

export const CartNoProducts: React.FC<Props> = () => {
    return (
        <>
            <h3>Пока пусто</h3>
            <div>Воспользуйтесь каталогом или поиском</div>
        </>
    );
};